import React from 'react';
import times from 'lodash/times';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PureCarsMeridianLogo from '../CommonHeader/PureCarsMeridianLogo';
import { InnerWrapper, LogoWrapper, MenuColumnWrapper, MenuWrapper, OuterWrapper, IconSkeleton, LabelSkeleton } from './styles';
export function MultiAppMenuPanelSkeleton() {
  return /*#__PURE__*/React.createElement(OuterWrapper, null, /*#__PURE__*/React.createElement(InnerWrapper, null, /*#__PURE__*/React.createElement(LogoWrapper, null, /*#__PURE__*/React.createElement(PureCarsMeridianLogo, null)), /*#__PURE__*/React.createElement(MenuWrapper, null, /*#__PURE__*/React.createElement(MenuColumnWrapper, {
    $level: 'primary'
  }, /*#__PURE__*/React.createElement(Tabs, {
    orientation: "vertical",
    variant: "fullWidth",
    value: false,
    indicatorColor: "secondary",
    textColor: "secondary",
    "aria-label": "icon label tabs example"
  }, times(3).map(function (index) {
    return /*#__PURE__*/React.createElement(Tab, {
      key: index,
      icon: /*#__PURE__*/React.createElement(IconSkeleton, null),
      label: /*#__PURE__*/React.createElement(LabelSkeleton, null)
    });
  }))), /*#__PURE__*/React.createElement(MenuColumnWrapper, {
    $level: 'secondary'
  }, /*#__PURE__*/React.createElement(List, {
    component: "nav"
  }, times(3).map(function (index) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: index,
      button: true
    }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement(LabelSkeleton, null)));
  }))))));
}
export default MultiAppMenuPanelSkeleton;